var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1855_6639)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5455 5.63635H14.3141C13.3277 5.63635 12.3818 6.06736 11.6843 6.83455C10.9869 7.60175 10.5951 8.64229 10.5951 9.72726V12.1818H8.36365V15.4545H10.5951V22.9091H13.5703V15.4545H15.8017L16.5455 12.1818H13.5703V9.72726C13.5703 9.51027 13.6486 9.30216 13.7881 9.14872C13.9276 8.99528 14.1168 8.90908 14.3141 8.90908H16.5455V5.63635Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1855_6639"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
};
export default SvgFacebook;